<div class="container">
  <div class="row justify-content-md-center">
    <div class="col-sm-12 col-md-6">

        <div class="jumbotron">
            <h3 class="display-4">Desafio FrontEnd</h3>
            <p class="lead">Desafio desenvolvido em Angular por Bruno Romeiro.</p>
            <hr class="my-4">

          <form (ngSubmit)="onSearch()">

                  <div class="mb-3">
                    <label for="username" class="form-label">Usuário do Github</label>
                    <input placeholder="Digite um Usuário Github" id="username" name="username" [(ngModel)]="datausername" class="form-control"/>

                  </div>

                  <button type="submit" class="btn btn-primary btn-block">Buscar</button>

          </form>

        </div>

    </div>

  </div>

  <!-- <div *ngIf="data">
    <ul *ngFor="let item of data.items">
      <li><img class="img" src="{{item.avatar_url}}" alt=""> {{item.login}}</li>
    </ul>
  </div> -->

  <div class="row" *ngIf="data">
    <div class="col">

      <table class="table">

        <tbody>
          <tr *ngFor="let item of data.items">
              <td>
                <img src="{{item.avatar_url}}" alt="{{item.login}}" class="img"><a routerLink="/user/{{item.login}}" routerLinkActive="router-link-active">{{item.login}}</a>
              </td>
          </tr>

        </tbody>
      </table>

  </div>

</div>

